import { render, staticRenderFns } from "./TimeOffIcon.vue?vue&type=template&id=2cb0eb79&scoped=true"
import script from "./TimeOffIcon.vue?vue&type=script&lang=js"
export * from "./TimeOffIcon.vue?vue&type=script&lang=js"
import style0 from "./TimeOffIcon.vue?vue&type=style&index=0&id=2cb0eb79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb0eb79",
  null
  
)

export default component.exports